<div class="bg-surface-0 dark:bg-surface-900">
    <div id="home" class="landing-wrapper overflow-hidden">
        <div class="container mx-auto">
            <div class="centerContainer flex justify-center flex-col">
                <div>
                    <img src="../../../assets/images/Cardio4Cities_Accelerator_logo.svg" alt="" />
                </div>
                <div>
                    <p>The CARDIO4Cities Simulator is a powerful, data-driven, strategic tool that helps cities transform their population's heart health at scale.</p>
                    <button>Get Started</button>
                </div>
            </div>
        </div>
    </div>
</div>
